import { AVAILABLE_CABINET_TYPES } from '../../../enums/cabinetTypes'

export const newCabinetFormSchema = {
  type: "object",
  properties: {
    bank: { type: "string", enum: AVAILABLE_CABINET_TYPES },

    credentials: {
      type: "object",
      properties: {
        login: { type: "string", minLength: 3, maxLength: 20 },
        password: { type: "string", minLength: 6 },
      },
      required: ["login", "password"],
    },

    baseInfo: {
      type: "object",
      properties: {
        name: { type: "string", minLength: 3 },
        birthDate: { type: "string", format: "date" },
        phone: { type: "string", minLength: 10 },
      },
      required: ["name", "birthDate", "phone"],
    },

    name: { type: "string", minLength: 3 },
    birthDate: { type: "string", format: "date" },
    phone: { type: "string", minLength: 10 },

    passport: {
      type: "object",
      properties: {
        series: { type: "string" },
        number: { type: "string" },
        issued: { type: "string", format: "date" },
        validityPeriod: { type: "string", format: "date" },
        issuingAuthority: { type: "string" },
        departmentCode: { type: "string" },
        registrationAddress: { type: "string" },
        address: { type: "string" },
      },
      required: [],
    },

    feedback: {
      type: "object",
      properties: {
        phoneNumber: { type: "string" },
        phoneType: { type: "string", enum: ["phone", "whatsApp"] },
      },
      required: [],
    },

    chat: {
      type: "object",
      properties: {
        defaultMessage: { type: "string" },
        autoOpen: { type: "string", enum: ["on", "off"] },
      },
      required: [],
    },

    balance: {
      type: "object",
      properties: {
        value: { type: "number" },
        currency: { type: "string", enum: ["rub", "usd", "eur"] },
      },
      required: [],
    },

    cabinetIdentifier: {
      type: "string",
      minLength: 12,
      maxLength: 36,
    }
  },
  required: ["bank", "credentials", "baseInfo", "passport", "feedback", "chat", "balance"],
};
